export default __webpack_public_path__ + "static/media/close.77dd5819.svg";